import { Button, TextField } from "@mui/material";
import { useState } from "react";
import { ConfirmDialog } from "../../components/ConfirmDialog";
import { useChangePassword } from "./api";
import { useNotify } from "../../app/useNotify";
import { errorMessageFor } from "../../api/client";

export function ChangePasswordDialog() {
  const [open, setOpen] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const change = useChangePassword();
  const notify = useNotify();

  const mismatch = confirmPassword !== "" && newPassword !== confirmPassword;
  const incomplete = !oldPassword || !newPassword || !confirmPassword;

  function reset() {
    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");
  }

  return (
    <>
      <Button variant="outlined" onClick={() => setOpen(true)}>
        Change password
      </Button>
      <ConfirmDialog
        open={open}
        title="Change password"
        confirmLabel="Change password"
        busy={change.isPending}
        confirmDisabled={incomplete || mismatch}
        onClose={() => {
          setOpen(false);
          reset();
        }}
        onConfirm={async () => {
          try {
            await change.mutateAsync({ oldPassword, newPassword, confirmPassword });
            notify.success("Password changed");
            setOpen(false);
            reset();
          } catch (error) {
            notify.error(errorMessageFor(error) ?? "Could not change your password.");
          }
        }}
      >
        <TextField
          label="Current password"
          type="password"
          value={oldPassword}
          onChange={(event) => setOldPassword(event.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="New password"
          type="password"
          value={newPassword}
          onChange={(event) => setNewPassword(event.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Confirm new password"
          type="password"
          value={confirmPassword}
          onChange={(event) => setConfirmPassword(event.target.value)}
          error={mismatch}
          helperText={mismatch ? "The passwords do not match." : undefined}
          fullWidth
          margin="normal"
        />
      </ConfirmDialog>
    </>
  );
}
